export const VIDEO = {
  entrance: "/videos/landing.mp4",
};

export const IMG = {
  nalukettu: "/Images/nadumuttam.png",
  door: "/Images/nadumuttam1.png",
  backwaters: "/Images/nadumuttam.png",
  nilavilakku: "/Images/about_bg.jpeg",
  sadya: "/Images/about_bg.jpeg",
  fishCurry: "/Images/about_bg.jpeg",
  karimeen: "/Images/nadumuttam.png",
  pookalam: "/Images/about_bg.jpeg",
  pazhamPori: "/Images/about_bg.jpeg",
  biryani: "/Images/nadumuttam.png",
  puttu: "/Images/nadumuttam1.png",
  payasam: "/Images/about_bg.jpeg",
  uruli: "/Images/nadumuttam1.png",
};

export const GALLERY = [
  { img: IMG.nalukettu, label: "THE HOUSE", caption: "THE VEEDU", desc: "A house dressed for celebration and memory.", ar: "wide" },
  { img: IMG.sadya, label: "FOOD", caption: "AT THE TABLE", desc: "Some meals become memories.", ar: "landscape", theme: "ivory" },
  { img: IMG.karimeen, label: "THE KITCHEN", caption: "THE HANDS BEHIND IT", desc: "Every dish begins somewhere.", ar: "portrait" },
  { img: IMG.fishCurry, label: "FOOD", caption: "FROM THE HEARTH", desc: "Where the fire begins.", ar: "landscape" },
  { img: IMG.pookalam, label: "CELEBRATIONS", caption: "ONAM AT THE VEEDU", desc: "A house dressed for celebration.", ar: "square", featured: true },
  { img: IMG.nilavilakku, label: "EVENINGS", caption: "AFTER HOURS", desc: "Music, food and people around the table.", ar: "tall", theme: "ivory" },
  { img: IMG.uruli, label: "THE HOUSE", caption: "THE COURTYARD", desc: "Where conversations linger.", ar: "landscape" },
  { img: IMG.backwaters, label: "OUTSIDE", caption: "AFTER THE RAIN", desc: "The courtyard before dinner.", ar: "wide" },
  { img: IMG.door, label: "THE HOUSE", caption: "THE ENTRANCE", desc: "Always open, always warm.", ar: "portrait", theme: "ivory" },
  { img: IMG.biryani, label: "FOOD", caption: "THE COAST", desc: "Spices that travelled oceans.", ar: "landscape" },
];

export const CHAPTERS = [
  { id: "entrance",   num: "01", name: "THE HOUSE",        theme: "dark" },
  { id: "story",      num: "02", name: "OUR STORY",        theme: "light" },
  { id: "table",      num: "03", name: "OUR MENU",         theme: "light" },
  { id: "chef-jomon", num: "04", name: "CHEF JOMON",       theme: "dark" },
  { id: "kitchen",    num: "05", name: "THE KITCHEN",      theme: "dark" },
  { id: "verandah",   num: "06", name: "HERITAGE GALLERY",  theme: "light" },
];

export const CONTACT = {
  address: "197-201 High Street, Hornchurch, Essex RM11 3XT",
  parking: "Nearest parking: Fentiman Way Car Park, RM11 1QX (2 Min Walking)",
  parkingMaps: "https://www.google.com/maps/dir/?api=1&destination=Fentiman+Way+Car+Park+Hornchurch+RM11+1QX",
  phone: "+44 (0) 01708 438 003",
  phoneHref: "tel:+4401708438003",
  mobile: "+44 (0) 7445 141 536",
  mobileHref: "tel:+447445141536",
  whatsapp: "https://wa.me/447445141536?text=I%20would%20like%20to%20reserve%20a%20table%20at%20Chef%20Jomon%27s%20Veedu",
  whatsappPreOpening: "https://wa.me/447445141536?text=Hello%20Chef%20Jomon%27s%20Veedu%2C%20I%20would%20like%20to%20enquire%20about%20your%20upcoming%20opening%20and%20table%20reservations",
  maps: "https://maps.app.goo.gl/FLUAkChHgMKrJpsB8",
  instagram: "https://www.instagram.com/chefjomon/?hl=en",
  facebook: "https://www.facebook.com/chefjomon/",
  wikipedia: "https://en.wikipedia.org/wiki/Jomon_Kuriakose",
  website: "https://www.chefjomon.com/",
  twitter: "https://x.com/chefjomon?lang=en",
  hours: "Mon: Closed · Tue–Fri: 16:30–23:00 (Last order: 22:30) · Sat–Sun: 13:00–23:00",
};



export const FOUNDER_BOOK = {
  title: "A.T.T.I.T.U.D.E",
  subtitle: "A Food Tale from God’s Own Country",
  fullTitle: "A.T.T.I.T.U.D.E – A Food Tale from God’s Own Country",
  author: "Chef Jomon",
  publisher: "CARNET",
  platform: "EVEME",
  cover: "/Images/attitude-book-cover.jpg",
  price: "£20.00",
  preOrderUrl: "https://eveme.uk/product/chef-jomons-attitude-pre-order/",
  malayalamIntro: "EVEME നിങ്ങൾക്ക് പരിചയപ്പെടുത്തുന്ന ഏറ്റവും പുതിയ പുസ്തകം, നമ്മുടെ സ്വന്തം സെലിബ്രിറ്റി ഷെഫ് ജോമോന്റെ A.T.T.I.T.U.D.E – A Food Tale from God’s Own Country.",
  malayalamBody: [
    "ഇത് വെറുമൊരു ആത്മകഥയല്ല...",
    "കേരളത്തിലെ ഒരു കൊച്ചു ഗ്രാമത്തിൽ വളർന്ന്.. അമ്മയുടെ പ്രാർത്ഥനയും ... ലക്ഷ്യ ബോധവും .. ആത്മവിശ്വാസവും കൊണ്ട്... ഉയരങ്ങൾ കീഴടക്കിയ ഒരു പച്ചയായ മനുഷ്യന്റെ അനുഭവങ്ങളുടെ നേർക്കാഴ്ച...",
    "നമ്മളെ സ്വപ്നം കാണാൻ പഠിപ്പിക്കുന്ന.. ആ സ്വപനത്തിലേക്കുള്ള ദിശാബോധം നൽകുന്ന പുസ്തകം ...",
    "ജീവിതത്തിൽ എന്തെങ്കിലുമൊക്കെ ആയിത്തീരണം എന്ന് ആഗ്രഹിക്കുന്ന നമ്മൾ ഓരോരുത്തരും വായിച്ചിരിക്കേണ്ട .. അനുഭവിച്ചറിയേണ്ട പുസ്തകം ...",
    "ജീവിതത്തെ മറ്റൊരു തലത്തിൽ എത്തിക്കാൻ നമ്മളെ പ്രചോദിപ്പിക്കുന്ന പുസ്തകം ഇപ്പോൾ EVEME യിൽ ലഭ്യമാണ്."
  ],
  englishSummary: "A journey seasoned with passion, resilience and dreams. Chef Jomon's ATTITUDE is more than a memoir — it’s a bold, unfiltered journey through the heat of the kitchen and the heart of a dreamer who grew up in a quiet Kerala village and conquered London’s culinary stage.",
  keyHighlights: [
    { title: "Origins & Heritage", desc: "Growing up in a Kerala village immersed in authentic flavours, family faith and humble beginnings." },
    { title: "Grit & Determination", desc: "Mastering commercial European and British kitchens through relentless discipline and perseverance." },
    { title: "Inspiring Dreams", desc: "A compass for anyone aspiring to turn passion into purpose and scale global heights." }
  ]
};
